/**
 * Do not edit directly, this file was auto-generated.
 */

export default {
  transition: {
    duration: {
      short: "100ms",
      default: "200ms",
      long: "400ms",
    },
    "timing-function": "ease-in-out",
  },
  color: {
    primary: {
      10: "#fff3f3",
      30: "#ff7370",
      50: "#fc5757",
      70: "#d4524f",
      90: "#a63633",
    },
    secondary: {
      10: "#ecf3f4",
      30: "#0f6378",
      50: "#035266",
      90: "#014554",
    },
    tertiary: {
      10: "#e3f8fb",
      30: "#a8eaf3",
      50: "#00c0db",
      70: "#00aac1",
    },
    quaternary: {
      10: "#fffbed",
      30: "#fccf5e",
      50: "#ffc200",
      70: "#f0b021",
      100: "#d29614",
    },
    brand: {
      primary: {
        10: "#ffe5fc",
        30: "#ffb0f7",
        50: "#ff91f0",
        70: "#eb73de",
      },
      secondary: {
        10: "#e4eaff",
        30: "#264ffa",
        50: "#0529fc",
        70: "#0833bd",
      },
    },
    neutral: {
      0: "#ffffff",
      10: "#fcfcfc",
      20: "#f7f7f5",
      30: "#e0ded9",
      35: "#b7b6b2",
      40: "#737370",
      50: "#4b4b4b",
      60: "#333330",
      70: "#181818",
    },
    success: {
      10: "#f2f8e9",
      50: "#81b928",
      90: "#659b1c",
    },
    information: {
      10: "#eaf5ff",
      50: "#2fa0fc",
      90: "#175db5",
    },
    warning: {
      10: "#fef6e7",
      50: "#f2a10c",
      90: "#ae6606",
    },
    error: {
      10: "#fceaea",
      50: "#e02d2d",
      90: "#a1162e",
    },
    ai: {
      primary: {
        10: "#f2e0f5",
        30: "#9035a2",
        70: "#5f246a",
        100: "#3d1744",
      },
      gradient: {
        10: "linear-gradient(90deg, rgba(144,53,162,0.3) 0%, rgba(252,87,87,0.3) 100%)",
        30: "linear-gradient(90deg, rgba(144,53,162,1) 0%, rgba(252,87,87,0.85) 100%)",
        70: "linear-gradient(90deg, rgba(109,40,123,1) 0%, rgba(251,35,35,0.85) 100%)",
        100: "linear-gradient(90deg, rgba(75,28,85,1) 0%, rgba(230,4,4,0.85) 100%)",
      },
    },
    text: {
      body: "#4b4b4b",
      title: "#333330",
      disabled: "#e0ded9",
    },
    state: {
      "disabled-border": "#b7b6b2",
      "disabled-background": "#f7f7f5",
      focus: "#035266",
      hover: "#035266",
      error: "#e02d2d",
      "hover-error": "#a1162e",
    },
    overlay: "#33333066",
    background: {
      skeleton: "linear-gradient(110deg, #f7f7f5 8%, #fcfcfc 18%, #f7f7f5 33%)",
    },
    shadow: {
      base: "#18181829",
    },
  },
  core: {
    spacing: {
      0: "2px",
      1: "4px",
      2: "8px",
      3: "12px",
      4: "16px",
      5: "20px",
      6: "24px",
      7: "28px",
      8: "32px",
      9: "40px",
      10: "48px",
      11: "56px",
      12: "64px",
    },
    zIndex: {
      fixedContent: 20,
      dropdown: 23,
      backdrop: 1050,
      productTour: 1060,
      walkthrough: 1070,
      dialog: 1080,
      tooltip: 1090,
      snackbar: 1100,
    },
    radius: {
      0: "0",
      1: "2px",
      2: "4px",
      3: "8px",
      4: "16px",
      5: "32px",
      6: "50%",
    },
    elevation: {
      0: "0 0 0 0 #18181829",
      1: "0 2px 4px 0 #18181829",
      2: "0 4px 12px 0 #18181829",
      3: "0 6px 24px 0 #18181829",
      4: "0 8px 32px 0 #18181829",
    },
  },
  lineHeight: {
    small: "1.05",
    large: "1.25",
  },
  font: {
    weight: {
      normal: "500",
      bold: "700",
    },
    family: {
      base: "'Moderat', Arial, Helvetica, sans-serif",
      title: "'Agrandir Tight', Arial, Helvetica, sans-serif",
    },
    size: {
      primary: {
        100: "11px",
        200: "12px",
        300: "14px",
        400: "16px",
        600: "20px",
        800: "24px",
      },
      secondary: {
        200: "28px",
        400: "36px",
        600: "46px",
        800: "52px",
      },
    },
  },
  form: {
    border: {
      width: "2px",
    },
    field: {
      height: {
        xxsmall: "24px",
        xsmall: "32px",
        small: "40px",
        medium: "48px",
        large: "64px",
      },
      radius: {
        xxsmall: "12px",
        xsmall: "16px",
        small: "20px",
        medium: "24px",
        large: "32px",
      },
      focus: {
        color: "#2fa0fc",
        width: "2px",
        shadow: "0 0 0 2px #2fa0fc",
      },
    },
  },
};
